import {withRouter} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import notificationBellIcon from '../../../assets/images/notification-bell';
import notificationBellWithAlertIcon from '../../../assets/images/notification-bell-with-alert';
import NotificationsModal from './dashboard/notifications_modal';
import '../../stylesheets/app_page_header.scss';

const NotificationBell = props => {
  const enabled = props.currentUser && !props.currentUser.roles.post_production;
  const [modalOpen, setModalOpen] = useState(false);
  useEffect(() => {
    if (!enabled) return undefined;
    const fetchCount = () => props.fetchNotificationCount(props.currentUser.id);
    const visibilityChanged = () => {if (!document.hidden) fetchCount();};
    const interval = setInterval(fetchCount, 300000);
    document.addEventListener('visibilitychange', visibilityChanged);
    fetchCount();
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', visibilityChanged);
    };
  }, [props.fetchNotificationCount, props.currentUser?.id, enabled]);
  if (!enabled) return null;
  const count = props.currentUser.unread_notifications || 0;
  return <div className="appNotifications">
    <NotificationsModal currentUser={props.currentUser} fetchNotificationCount={props.fetchNotificationCount} unread_notification_count={count} modalOpen={modalOpen} closeModal={() => setModalOpen(false)}/>
    <button type="button" className="notificationBellGroup appNotificationButton" aria-label={`Notifications (${count} unread)`} aria-haspopup="dialog" aria-expanded={modalOpen} onClick={() => setModalOpen(true)}>
      <img className="notificationBell" src={count > 0 ? notificationBellWithAlertIcon : notificationBellIcon} alt=""/>
      <span className="notificationDescription">{count} Notifications</span>
    </button>
  </div>;
};
export default withRouter(NotificationBell);
